//
//

import { mapGetters, mapActions } from "vuex";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import createAppDialog from "@/components/apps/createAppDialog.vue";
import importAppDialog from "@/components/apps/importAppDialog.vue";

export default {
    name: "NoAppsPage",
    components: {
        AQEmptyState,
        createAppDialog,
        importAppDialog
    },
    props: {
        mobileView: { type: Boolean, default: false }
    },
    data() {
        return {
            pageName: "Home",
            createNewApp: false,
            importApp: false
        };
    },
    computed: {
        ...mapGetters("userProfile", ["userCookieInfo"]),
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("version", ["latestVersionId"])
    },
    methods: {
        ...mapActions("version", ["getLatestVersionId"]),
        addApplication() {
            this.createNewApp = true;
            this.$store.commit("apps/setCurrentApp", {});
            this.getLatestVersionId().then(() => {
                this.currentApp.appVersion = this.latestVersionId;
            });
        }
    }
};
